<mat-tab-group [(selectedIndex)]="activeTabIndex">
  <mat-tab label="Connections">
    <app-feed-connections></app-feed-connections>
  </mat-tab>

  <mat-tab label="Product Feed Overrides">
    <app-feed-list></app-feed-list>
  </mat-tab>
</mat-tab-group>
